<div class="row mt-3 mb-3">

  <div class="col-md-6">

    <h4>
      Procesos del cliente
    </h4>

  </div>

  <div class="col-md-6 text-right">

    <button
      nbButton
      status="success"
      (click)="openAddProcessModal()">

      <nb-icon icon="plus-outline"></nb-icon>
      Nuevo proceso

    </button>

  </div>

</div>

<div
  class="row"
  *ngIf="!processes?.length">

  <div class="col-md-12">

    <nb-card>

      <nb-card-body class="text-center">

        No existen procesos registrados para este cliente.

      </nb-card-body>

    </nb-card>

  </div>

</div>

<div class="row">

  <div
    class="col-md-6 col-lg-4 mb-3"
    *ngFor="let process of processes">

    <nb-card>

      <nb-card-header>

        <div
          class="d-flex justify-content-between align-items-center">

          <strong>

            {{ process.nombreProceso || 'Proceso sin nombre' }}

          </strong>

          <small>

            {{ process.fechaActualizacion | date:'dd/MM/yyyy' }}

          </small>

        </div>

      </nb-card-header>

      <nb-card-body>

        <div class="mb-3">

          <strong>
            Descripción general
          </strong>

          <p class="mt-2 mb-0">

            {{ process.descripcionGeneral || 'Sin descripción' }}

          </p>

        </div>

        <hr>

        <div class="mb-2">

          <strong>
            Herramientas:
          </strong>

          {{ process.herramientas?.length || 0 }}

        </div>

        <div class="mb-2">

          <strong>
            Pasos:
          </strong>

          {{ process.procedimiento?.length || 0 }}

        </div>

        <div class="mb-2">

          <strong>
            Plantillas:
          </strong>

          {{ process.plantillas?.length || 0 }}

        </div>

        <div class="mb-2">

          <strong>
            Casos especiales:
          </strong>

          {{ process.casosEspeciales?.length || 0 }}

        </div>

        <div class="mb-2">

          <strong>
            Información importante:
          </strong>

          {{ process.informacionImportante?.length || 0 }}

        </div>

        <div class="mb-0">

          <strong>
            Excepciones:
          </strong>

          {{ process.excepciones?.length || 0 }}

        </div>

      </nb-card-body>

      <nb-card-footer>

        <div class="text-right">

          <button
            nbButton
            size="small"
            status="info"
            class="mr-2"
            (click)="editProcess(process)">

            <nb-icon icon="edit-outline"></nb-icon>

            Ver

          </button>

          <button
            nbButton
            size="small"
            status="danger"
            (click)="deleteProcess(process)">

            <nb-icon icon="trash-outline"></nb-icon>

            Eliminar

          </button>

        </div>

      </nb-card-footer>

    </nb-card>

  </div>

</div>